const apiUrl = process.env.REACT_APP_API_URL;
export const GetTornDubte = async (id_aula : string, id_usuari : string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/dubtes/torn/dubte?usuari=${id_usuari}`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
